import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  IconMail,
  IconLoader2,
  IconAlertCircle,
  IconArrowLeft,
  IconCircleCheck
} from '@tabler/icons-react';
import LogoIcon from '../components/LogoIcon';
import { authAPI } from '../services/api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError('Введите корректный email');
      return;
    }
    setLoading(true);
    try {
      await authAPI.forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.message || 'Не удалось отправить письмо');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-dark-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2.5">
            <LogoIcon />
            <span className="text-xl font-bold text-gray-900 dark:text-white">
              XN Connect
            </span>
          </Link>
        </div>

        <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-2xl p-5 sm:p-8">
          {sent ? (
            <>
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <IconCircleCheck className="w-8 h-8 text-green-500" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Письмо отправлено
                </h2>
                <p className="text-gray-600 dark:text-dark-400 text-sm leading-relaxed">
                  Если аккаунт с email{' '}
                  <span className="font-medium text-gray-900 dark:text-white">{email}</span>{' '}
                  существует, на него будет отправлено письмо с кнопкой «Сбросить пароль».
                  Проверьте папку «Спам», если письмо не пришло.
                </p>
              </div>
              <Link
                to="/login"
                className="inline-block w-full py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white transition-colors text-center"
              >
                Вернуться ко входу
              </Link>
            </>
          ) : (
            <>
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-primary-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <IconMail className="w-8 h-8 text-primary-500" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                  Сброс пароля
                </h2>
                <p className="text-gray-600 dark:text-dark-400 text-sm">
                  Укажите email, привязанный к аккаунту. Мы отправим письмо с кнопкой для сброса пароля.
                </p>
              </div>

              {error && (
                <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg mb-6">
                  <IconAlertCircle className="w-5 h-5 text-red-400 flex-shrink-0" />
                  <p className="text-red-400 text-sm">{error}</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-dark-300 mb-2">
                    Email
                  </label>
                  <div className="relative">
                    <IconMail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 dark:text-dark-600" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="w-full pl-10 pr-4 py-3 bg-white dark:bg-dark-950 border border-gray-300 dark:border-dark-800 rounded-lg text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-dark-600 focus:outline-none focus:border-primary-500 transition-colors"
                      disabled={loading}
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white flex items-center justify-center space-x-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <IconLoader2 className="w-5 h-5 animate-spin" />
                  ) : (
                    <span>Отправить письмо</span>
                  )}
                </button>
              </form>
            </>
          )}

          <Link
            to="/login"
            className="flex items-center justify-center gap-1 mt-6 text-sm text-gray-600 dark:text-dark-500 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            <IconArrowLeft className="w-4 h-4" />
            Вернуться ко входу
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
